import React from "react";
import { BUSINESS_TYPES } from "../constants";

export function BusinessTypePicker({ value, onChange, t }) {
  return (
    <div className="form-group">
      <label className="field-label">{t("business_type")}</label>
      <div className="btype-grid">
        {BUSINESS_TYPES.map(bt => (
          <button key={bt.id} className={`btype-btn ${value === bt.id ? "btype-active" : ""}`} onClick={() => onChange(bt.id)} type="button">
            <span className="btype-icon">{bt.icon}</span>
            <span className="btype-label">{t(bt.label)}</span>
          </button>
        ))}
      </div>
      {value && (() => {
        const bt = BUSINESS_TYPES.find(b => b.id === value);
        return (
          <div className="btype-info">
            <div className="btype-info-row"><span className="btype-info-key">{t("tax_authority")}</span><span className="btype-info-val">{t(bt.authority)}</span></div>
            <div className="btype-info-row"><span className="btype-info-key">{t("typical_rate")}</span><span className="btype-info-val">{t(bt.rates)}</span></div>
            <div className="btype-info-row"><span className="btype-info-key">{t("note")}</span><span className="btype-info-val">{t(bt.taxNote)}</span></div>
          </div>
        );
      })()}
    </div>
  );
}
